const login = {
  title: "Inicio de Sesión: Metax IMS",
  email: "Correo Electrónico",
  password: "Contraseña",
  loginbtn: "Iniciar Sesión",
  messages: {
    default: "Este campo es requerido",
    email: {
      required: "Correo electrónico requirido",
      valid: "Correo electrónico inválido"
    },
    password: {
      required: "Contraseña requerida",
      valid: "La contraseña debe ser 6 characteres como mínimo",
      recover: "RECUPERA LA CONTRASEÑA",
      send: "ENVIAR RECUPERACION DE CONTRASEÑA"
    }
  }
};
export default login;
